import React from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Layout from '@components/Layout/Layout';
import Seo from '@components/SEO/SEO';
import SliceZone from '@components/NewSliceZone/NewSliceZone';
import pageDataToSEOProps from '@prismic/utils/pageDataToSEOProps';
import TerminalCTA from '@components/TerminalCTA/TerminalCTA';

// Combine legacy slices with new Slice Machine slices
export const processSlices = (slices, dataRaw) => {
  return (
    slices?.map(slice => {
      if (slice.version === 'initial') {
        // Find the corresponding slice in dataRaw
        const rawSlice = dataRaw?.body?.find(
          rawSlice => rawSlice.id === slice.id && rawSlice.slice_type === slice.slice_type
        );

        if (rawSlice) {
          return rawSlice;
        }
      }

      return slice;
    }) || []
  );
};

const MarketplaceTypePageTemplate = ({ location, data }) => {
  const pageDocument = data?.prismicMarketplaceTypePage?.data;
  const dataRaw = data?.prismicMarketplaceTypePage?.dataRaw;
  const slices = pageDocument.body;

  const processedSlices = processSlices(slices, dataRaw);

  const urlPath = data?.prismicMarketplaceTypePage?.url || data.url;

  return (
    <Layout page="marketplace" location={location}>
      <Seo {...pageDataToSEOProps(pageDocument, urlPath)} />
      <SliceZone slices={processedSlices} />
      <TerminalCTA />
    </Layout>
  );
};

export const query = graphql`
  query MarketplaceTypePageQuery($uid: String!) {
    prismicMarketplaceTypePage(uid: { eq: $uid }) {
      _previewable
      uid
      url
      type
      data {
        seo_canonical_url
        seo_description
        seo_og_description
        seo_og_image {
          alt
          url
        }
        seo_og_title
        seo_title
        seo_no_index
        body {
          ... on PrismicSlice {
            id
            slice_label
            slice_type
          }
          ...MarketplaceTypePageDataBodyHeroCarousel
          ...MarketplaceTypePageDataBodyFeatureHeadingTabs
          ...MarketplaceTypePageDataBodyFeatureRow
          ...MarketplaceTypePageDataBodyCustomerStoriesCarousel
          ...MarketplaceTypePageDataBodyStats
          ... on PrismicFaqSectionSliceDefault {
            version
          }
        }
      }
      dataRaw
    }
  }
`;

export default withPrismicPreview(MarketplaceTypePageTemplate);
